import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Layout route para /dashboard/$dashboardId/catalogo
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/catalogo',
)({
  component: () => (
    <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
      <Outlet />
    </ProtectedRoute>
  ),
})
